<div class="bar padding-1" fxLayout="row wrap">
  <div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxFlex="50" fxFlex.lt-md="auto" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
      <a [routerLink]="'/home'" class="logo-link">
        <img src="./assets/logo.png" class="logo" />
      </a>
      <h1>SSO</h1>
    </div>
    <div fxFlex="50" fxFlex.lt-md="auto" fxLayout="row" fxLayoutAlign="end center">
      <div *ngIf="user" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px">
        <div class="user-info" fxHide.xs>
          <div class="bold user-full-name">{{'welcome' |translate}} {{user['Username']}}</div>
        </div>
        <div>
          <i class="fas fa-user fa-2x clickable primary-color action-icon padding-1" [matMenuTriggerFor]="userMenu"></i>
        </div>
        <mat-menu #userMenu="matMenu">
          <button mat-menu-item routerLink="/user-profile" *ngIf="showChangePass">
            <i class="fas fa-key"></i>
            {{'changePassword'|translate}}
          </button>
          <button mat-menu-item (click)="logout()">
            <i class="fas fa-door-open"></i>
            {{'logout'|translate}}
          </button>
        </mat-menu>
      </div>
      <div>
        <mat-button-toggle-group name="language" [value]="currentLanguage" (change)="changeLanguage($event)">
          <mat-button-toggle value="ar_jo" matTooltip="العربية" class="bold">
            ع
          </mat-button-toggle>
          <mat-button-toggle value="en_us" matTooltip="English" class="bold">
            EN
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
  </div>
</div>